import ProductHelpers from '../product/base';

function formatDate (date, formatPattern) {
    if (formatPattern === 'dd-mm-yyyy') {
        return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
            date.getFullYear();
    } else if (formatPattern === 'mm-dd-yyyy') {
        return ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + '-' +
            date.getFullYear();
    } else if (formatPattern === 'yyyy年mm月dd日') {
        var dateParsed = (date.getFullYear() + '年' + ('0' + (date.getMonth() + 1)).slice(-2) + '月' + ('0' + date.getDate()).slice(-2) + '日');
        return dateParsed;
    }
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
const getAddToCartUrl = () => {
    return $('.add-to-cart-url').val();
};

class GiftcardHelpers {
    addToCart () {
        $('body').on('click', 'button.js-giftCardPage-giftCardAddToCartGlobal', e => {
            e.preventDefault();

            // Validate price
            let amountSelectorOk = true;
            var formatPattern = $('.datepickerTriggerElement').data('date-format-pattern');
            if (!$('.js-giftcard-amount-option:checked').val() && !$('.js-giftcard-amount-manual').val()) {
                $('.js-price-validation-error-not-selected').removeClass('hidden');
                amountSelectorOk = false;
            }

            // check if custom amount is in the possible range
            let minAmount = $('.js-giftcard-amount-manual').data('min');
            let maxAmount = $('.js-giftcard-amount-manual').data('max');

            if ($('.js-giftcard-amount-manual').val() && (parseFloat($('.js-giftcard-amount-manual').val()) < minAmount || parseFloat($('.js-giftcard-amount-manual').val()) > maxAmount)) {
                amountSelectorOk = false;
            }

            let errors = [];
            let container = $('.parsleyValidatableElement');
            for (let i = 0; i < container.length; i++) {
                let validator = container.eq(i).parsley();
                validator.validate();
                if (!validator.isValid()) {
                    errors.push(validator);
                }
            }

            if (errors.length > 0 || !amountSelectorOk) {
                return;
            }

            let addToCartUrl;
            let pid;

            pid = ProductHelpers.methods.getPidValue($(e.currentTarget));

            var $productContainer = $(e.currentTarget).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(e.currentTarget).closest('.quickview-modals').find('.product-detail');
            }

            addToCartUrl = getAddToCartUrl();

            let uid = $(e.currentTarget).data('uid');

            let country = $('#countrySelector').val();
            let destinationName = $('.js-giftcardNameTo').val();
            let destinationMail = $('#giftcard--mail-to').val();
            let senderName = $('.js-giftcardYourName').val();
            let message = $('#contact-form-message').val() || '';

            let amount = $('.js-giftcard-amount-manual').val() || $('.js-giftcard-amount-option:checked').val();

            let dateString = $('.datepickerTriggerElement').data('date');
            if (dateString.match(/-/g).length !== 2) {
                dateString = formatDate(new Date(dateString), formatPattern);
            }

            let imgCode = $(e.currentTarget).data('egc-image-name');
            let giftcardGender;
            let urlParams = new URLSearchParams(window.location.search);
            let productGender = urlParams.get('type');
            if (productGender) {
                giftcardGender = productGender === 'M' ? '2' : '1';
            } else {
                giftcardGender = '';
            }
            var form = {
                pid: pid,
                quantity: 1,
                uuid: uid,
                destinationName: destinationName,
                destinationMail: destinationMail,
                message: message,
                senderName: senderName,
                amount: amount,
                shippingDate: dateString,
                country: country,
                imageCode: imgCode,
                giftcardGender: giftcardGender
            };

            $(e.currentTarget).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.spinner().start();
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: data => {
                        $('body').trigger('product:afterAddToCartGiftCard', data);
                        $('.js-mainHeader-minicart').trigger('count:update', data);
                        $.spinner().stop();
                    },
                    error: () => {
                        $.spinner().stop();
                    }
                });
            }
        });
    };
}

const giftcardHelper = new GiftcardHelpers();
export default giftcardHelper;
